// common
export const NO_SITE_FOUND = 'NO_SITE_FOUND';
export const SHOW_SITES = 'SHOW_SITES';
export const GET_SITES_ERROR = 'GET_SITES_ERROR';
export const SELECTING_SITE = 'SELECTING_SITE';
export const SITE_SELECTED = 'SITE_SELECTED';
export const REDIRECT_TO_SITE = 'REDIRECT_TO_SITE';

// auth
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const STOP_APP_LOADING = 'STOP_APP_LOADING';
export const UPDATE_AUTH_INPUTS = 'UPDATE_AUTH_INPUTS';
export const STORE_AUTH_DATA = 'STORE_AUTH_DATA';
export const TOGGLE_AUTH_LOADING = 'TOGGLE_AUTH_LOADING';
export const TOGGLE_AUTH_ERROR = 'TOGGLE_AUTH_ERROR';
export const UPDATE_AUTH_ERRORS = 'UPDATE_AUTH_ERRORS';
export const PRINT_SUCCESS_MSG = 'PRINT_SUCCESS_MSG';
export const AUTH_UNMOUNT = 'AUTH_UNMOUNT';
export const RESET_AUTH_FORM = 'RESET_AUTH_FORM';
export const SET_OTP_SENT = 'SET_OTP_SENT';
export const CLEAR_AUTH_ERRORS = 'CLEAR_AUTH_ERRORS';

// profile
export const TOGGLE_PROFILE_LOADING = 'TOGGLE_PROFILE_LOADING';
export const TOGGLE_PROFILE_ERROR = 'TOGGLE_PROFILE_ERROR';
export const UPDATE_PROFILE_INPUTS = 'UPDATE_PROFILE_INPUTS';
export const UPDATE_FILES = 'UPDATE_FILES';
export const UPDATE_PROFILE_ERRORS = 'UPDATE_PROFILE_ERRORS';
export const PROFILE_UNMOUNT = 'PROFILE_UNMOUNT';
export const SHOW_PROFILE_STATUS = 'SHOW_PROFILE_STATUS';
export const REDIRECT_TO_STEP = 'REDIRECT_TO_STEP';
export const SHOW_PROFILE_ERROR = 'SHOW_PROFILE_ERROR';
export const SHOW_PROFILE = 'SHOW_PROFILE';
export const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE';
export const UPDATE_BRANCH_FIELD_STATUS = 'UPDATE_BRANCH_FIELD_STATUS';

// dashboard
export const TOGGLE_DASHBOARD_LOADING = 'TOGGLE_DASHBOARD_LOADING';
export const DISPLAY_FEED = 'DISPLAY_FEED';
export const DASHBOARD_ERROR = 'DASHBOARD_ERROR';
export const FEED_UNMOUNT = 'FEED_UNMOUNT';

// activities
export const TOGGLE_ACTIVITIES_ERROR = 'TOGGLE_ACTIVITIES_ERROR';
export const UNMOUNT_ACTIVITIES = 'UNMOUNT_ACTIVITIES';
export const SHOW_ACTIVITIES_ERROR = 'SHOW_ACTIVITIES_ERROR';
export const TOGGLE_ACTIVITIES_LOADING = 'TOGGLE_ACTIVITIES_LOADING';
export const SHOW_ACTIVITY_LIST = 'SHOW_ACTIVITY_LIST';
export const SHOW_ACTIVITY = 'SHOW_ACTIVITY';
export const TOGGLE_ACTION_LOADING = 'TOGGLE_ACTION_LOADING';
export const SHOW_ACTION_ERROR = 'SHOW_ACTION_ERROR';
export const UPDATE_ACTIVITY_INPUTS = 'UPDATE_ACTIVITY_INPUTS';
export const ACTIVITY_SUCCESS = 'ACTIVITY_SUCCESS';

// search
export const TOGGLE_SEARCH_LOADING = 'TOGGLE_SEARCH_LOADING';
export const SHOW_SEARCH_ERROR = 'SHOW_SEARCH_ERROR';
export const UNMOUNT_SEARCH = 'UNMOUNT_SEARCH';
export const UPDATE_SEARCH_INPUTS = 'UPDATE_SEARCH_INPUTS';
export const SHOW_SEARCH_RESULTS = 'SHOW_SEARCH_RESULTS';
export const SEARCH_ACTION_LOADING = 'SEARCH_ACTION_LOADING';
export const SEARCH_ACTION_MESSAGE = 'SEARCH_ACTION_MESSAGE';
export const SHOW_SAVED = 'SHOW_SAVED';
export const SAVE_SELECTED_VALUES = 'SAVE_SELECTED_VALUES';

// main
export const TOGGLE_MAIN_LOADING = 'TOGGLE_MAIN_LOADING';
export const SHOW_MAIN_ERROR = 'SHOW_MAIN_ERROR';
export const UNMOUNT_MAIN = 'UNMOUNT_MAIN';
export const DEEP_UNMOUNT_MAIN = 'DEEP_UNMOUNT_MAIN';
export const SHOW_EVENTS = 'SHOW_EVENTS';
export const SHOW_NEWS = 'SHOW_NEWS';
export const SHOW_ALBUMS = 'SHOW_ALBUMS';
export const SHOW_EVENT_DETAIL = 'SHOW_EVENT_DETAIL';
export const SHOW_NEWS_DETAIL = 'SHOW_NEWS_DETAIL';
export const SHOW_ALBUM_DETAIL = 'SHOW_ALBUM_DETAIL';
export const SHOW_MAIN_ACTION_ERROR = 'SHOW_MAIN_ACTION_ERROR';
export const EVENT_JOINED = 'EVENT_JOINED';
export const SHOW_SITE_SETTINGS = 'SHOW_SITE_SETTINGS';
export const TOGGLE_MAIN_ACTION_LOADING = 'TOGGLE_MAIN_ACTION_LOADING';
export const UPDATE_MAIN_INPUTS = 'UPDATE_MAIN_INPUTS';



// WEBPACK FOOTER //
// ./src/config/actionTypes.js